import React, { useEffect, useState } from 'react';
import Handler from '../Helpers/Handler';
import { Input, Badge, Container } from 'reactstrap';
import Pagination from '../Helpers/Pagination';

const STATUS_COLOR = {
    placed: "warning",
    paid: "info",
    delivered: "success",
    cancelled: "danger",
    pending: "secondary"
};

const List = () => {
    const formatIST = (utcTime) => {
        if (!utcTime) return "-";
        const iso = utcTime.replace(" ", "T") + "Z";
        return new Date(iso).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const [total, setTotal] = useState(0);

    const getData = async () => {
        const res = await Handler({
            method: "get",
            url: `/customer/list.php?search=${search}&page=${page}`
        });

        if (res?.success) {
            setData(res.data || []);
            setPage(res.page || 1);

            if (page === 1 && res.data?.length < limit) {
                setTotal(res.data.length);
            } else {
                setTotal(page * limit + 1);
            }
        }
    };

    useEffect(() => { getData(); }, [page]);

    useEffect(() => {
        const delay = setTimeout(() => {
            setPage(1);
            getData();
        }, 400);
        return () => clearTimeout(delay);
    }, [search]);

    const totalPages = Math.ceil(total / limit);

    return (
        <div className="dashboard-wrapper py-3 py-md-4">
            <style>{`
                @media (max-width: 576px) {
                    .dashboard-header-flex {
                        flex-direction: column;
                        align-items: flex-start !important;
                        gap: 15px;
                    }
                    .searchbox-container {
                        width: 100% !important;
                    }
                    .searchbox {
                        width: 100% !important;
                    }
                    .dash-card {
                        padding: 15px !important;
                    }
                    .modern-table {
                        font-size: 13px;
                    }
                }
                .modern-table th {
                    white-space: nowrap;
                    background-color: #f8f9fa;
                }
                .modern-table td {
                    white-space: nowrap;
                }
            `}</style>

            <Container fluid="lg">
                {/* HEADER Section */}
                <div className="d-flex justify-content-between align-items-center mb-4 dashboard-header-flex">
                    <h5 className="section-heading mb-0">
                        <i className="bx bxs-user me-2 text-primary"></i> Customer List
                    </h5>

                    <div className="searchbox-container" style={{ minWidth: '250px' }}>
                        <Input
                            className="searchbox shadow-sm"
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search Name / Mobile..."
                        />
                    </div>
                </div>

                {/* TABLE Section */}
                <div className="dash-card p-4 mb-4 bg-white shadow-sm rounded">
                    <div className="table-responsive">
                        <table className="table modern-table align-middle border-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Customer</th>
                                    <th>Mobile</th>
                                    <th>Last Order</th>
                                    <th>Status</th>
                                    <th>Items / Amount</th>
                                    <th>Total Orders</th>
                                    <th>Total Earned</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{(page - 1) * limit + index + 1}</td>

                                            <td className="fw-semibold text-capitalize">
                                                {item.customer_name}
                                            </td>

                                            <td>{item.customer_mobile}</td>

                                            <td>
                                                <span className="d-block">{item.last_order?.date_time ? formatIST(item.last_order.date_time) : '-'}</span>
                                                <div className="small text-muted" style={{ fontSize: '11px' }}>
                                                    ID: {item.last_order?.order_id || '-'}
                                                </div>
                                            </td>

                                            <td>
                                                <Badge color={STATUS_COLOR[item.last_order?.status] || 'secondary'} pill>
                                                    {item.last_order?.status || 'N/A'}
                                                </Badge>
                                            </td>

                                            <td>
                                                <span className="fw-medium">{item.last_order?.items?.length || 0} items</span>
                                                <div className="small text-muted fw-bold">
                                                    ₹{item.last_order?.total || 0}
                                                </div>
                                            </td>

                                            <td className="text-center">
                                                <Badge color="primary" outline>
                                                    {item.total_orders}
                                                </Badge>
                                            </td>

                                            <td className="fw-bold text-success">
                                                ₹{item.total_renew}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-5 text-muted">
                                            No Customers Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION Section */}
                    <div className="mt-4 d-flex justify-content-center overflow-auto">
                        <Pagination
                            page={page}
                            total={total}
                            limit={limit}
                            onPrev={() => page > 1 && setPage(page - 1)}
                            onNext={() => page < totalPages && setPage(page + 1)}
                        />
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default List;